import {isSupport, xda} from '@hybird/flutter'
import {useDeviceStore} from '@/store/home'
import {messageAmount} from '@/api/notice/notice'
import {switchEnterprise} from "@/api/me/me";
import {Toast} from "vant";
import {getDeviceInfo} from "@/utils/env";
import {changeToRead} from '@/api/notice/notice'


// 初始化极光推送
export const initJPush = async (router) => {
  const deviceInfo = getDeviceInfo()
  console.log('initJPush',deviceInfo ? JSON.stringify(deviceInfo) : 'null')

  return xda
          .jpush({
            onOpenNotification: (data) =>
                    handlePushNavigation(data, deviceInfo, router),
            onReceiveNotification: (data) => {
              handleReceiveNotification(data, deviceInfo);
              console.log('onReceiveNotification', JSON.stringify(data))
            }
          })
          .catch((err) => {
            console.log(err)
          })
}

const parseNotification = (data, deviceInfo) => {
  console.log('onOpenNotification', JSON.stringify(data))
  console.log(data.extras['cn.jpush.android.EXTRA'])

  let jData = {}

  if (deviceInfo.platform === 'android') {
    const extra = data.extras['cn.jpush.android.EXTRA'];
    if (extra instanceof String) {
      jData = JSON.parse(data.extras['cn.jpush.android.EXTRA'])
    } else {
      jData = extra;
    }
  } else if (deviceInfo.platform === 'iOS') {
    jData = data.extras
  }

  jData.extras = data.extras;

  return jData;
}

// 处理通知打开事件
const handleReceiveNotification = async (data, deviceInfo) => {
  const jData = parseNotification(data, deviceInfo);

  const userInfo = getCurrInfo();

  const clearNotification = async () => {
    await xda.clearNotification(jData.extras["cn.jpush.android.NOTIFICATION_ID"]).catch(e => {
      console.warn("删除jpush失败了?", e);
    });
  }

  if (!userInfo || !userInfo.currEnterpriseId || !userInfo.currEnterpriseId) {
    console.log("handleReceiveNotification", "没有登录");
    await clearNotification();
    return;
  }

  const enterpriseId = jData.enterpriseId
  const staffId = jData.staffId

  if ((staffId != null && userInfo.currentStaffId !== staffId) || userInfo.currEnterpriseId !== enterpriseId) {
    await xda.clearNotification(jData.extras["cn.jpush.android.NOTIFICATION_ID"]).catch(e => {
      console.warn("删除jpush失败了?", e);
    });
    return;
  }

  console.log('handleReceiveNotification', jData);
  await getBadge();
}

const getCurrInfo = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  let currentStaffId = localStorage.getItem('currentStaffID')
  let currEnterpriseId = localStorage.getItem('enterpriseId')

  if (userInfo) {
    if (!currentStaffId) {
      currentStaffId = userInfo.result.staffId
    }

    if (!currEnterpriseId) {
      currEnterpriseId = userInfo.result.enterpriseId
    }
  }

  return {
    currentStaffId: currentStaffId ? parseInt(currentStaffId) : currentStaffId,
    currEnterpriseId: currEnterpriseId ? parseInt(currEnterpriseId) : currEnterpriseId
  }
}

// 处理推送跳转
const handlePushNavigation = async (
        data, deviceInfo,
        router
) => {
  const jData = parseNotification(data, deviceInfo);
  // const router = useRouter()
  const id = jData.businessId
  const type = jData.businessType
  const messagePushId = jData.messagePushId
  const enterpriseId = jData.enterpriseId
  const enterpriseName = jData.enterpriseName
  const staffId = jData.staffId

  console.log('id', jData.id)
  console.log('type', jData.type)
  console.log('messagePushId', jData.messagePushId)
  console.log('enterpriseId', jData.enterpriseId)
  console.log('enterpriseName', jData.enterpriseName)
  console.log('jData', jData)
  console.log('router', router.currentRoute.value)

  const userInfo = getCurrInfo();

  if ((staffId != null && userInfo.currentStaffId !== staffId)) {
    Toast("当前通知与您登录的账号不一致");
    return;
  } else if (userInfo.currEnterpriseId !== enterpriseId) {
    const res = await handleEnterpriseSwitch(enterpriseId);

    if (!res.success) {
      return;
    }
  }

  const deviceStore = useDeviceStore()
  const currentCpId = JSON.parse(localStorage.getItem('userInfo'))?.result
          ?.enterpriseId
  // 通知状态改为已读
  await changeToRead(messagePushId)
  //跳转抄送
  if (type === 12) {
    router.push({
      path: '/informDetail',
      query: {
        documentId: jData.businessId,
        isCarbonCopy: type === 12,
        taskId: jData.documentViceId || jData.dataId,
        processInstanceId: jData.dataId,
        dataId: jData.businessId,
        processMold: jData.processMold,
        recordType: jData.recordType
      }
    })
  } else if (type === 43) {
    // 跳转审批
    router.push({
      path: '/approveDetails',
      query: {
        documentId: jData.businessId,
        isCarbonCopy: type === 12,
        taskId: jData.documentViceId || jData.dataId,
        processInstanceId: jData.dataId,
        dataId: jData.businessId,
        processMold: jData.processMold,
        recordType: jData.recordType
      }
    })
  } else if ([1, 13, 15, 26, 36, 39, 43, 44, 45, 46, 47].includes(type)) {
    router.push({
      path: '/approveDetails',
      query: {
        documentId: jData.documentId || jData.businessId,
        isCarbonCopy: type === 12,
        taskId: jData.documentViceId || jData.dataId,
        processInstanceId: jData.dataId,
        dataId: jData.businessId,
        processMold: jData.processMold,
        recordType: jData.recordType
      }
    })
  } else if ([7, 8, 14, 22, 23, 24, 25, 27].includes(type)) {
    // 记录入口
    deviceStore.setNotDisConnect(false)

    // 审批通过、拒绝、流程终止 并且是特定流程类型时跳转到审批详情
    if (
            [7, 8, 22].includes(type) &&
            [3, 4, 5, 6, 7].includes(jData.processMold)
    ) {
      return router.push({
        path: '/approveDetails',
        query: {
          documentId: jData.documentId || jData.businessId,
          isCarbonCopy: type === 12,
          taskId: jData.documentViceId || jData.dataId,
          processInstanceId: jData.dataId,
          dataId: jData.businessId,
          processMold: jData.processMold,
          recordType: jData.recordType,
          pageTitle: '申请详情',
          isI: true
        }
      })
    }

    // 跳转申请详情
    router.push({
      path: jData.digital ? '/applyStampingDetail' : '/applyDetail',
      query: {
        documentId: jData.businessId
      }
    })
  } else if (type === 2) {
    // 跳远程审批详情
    router.push({
      path: '/remoteConfirm',
      query: {
        businessId: jData.businessId,
        businessType: type
      }
    })
  } else if (type === 4 || type === 9) {
    if (currentCpId === enterpriseId) {
      router.push({
        path: '/warningList',
        query: {type: 2}
      })
    }
  } else if (type === 10) {
    router.push({
      path: '/applyDetail',
      query: {id}
    })
  } else if ([16, 37, 38].includes(type)) {
    const status = type === 16 ? parseInt(jData.dataId) : jData.documentStatus
    router.push({
      path: '/applyDetail',
      query: {
        documentId: jData.documentId || jData.businessId
      }
    })
  } else if (type === 18) {
    console.log('OCR对比失败推送', jData)
    router.push({
      path: '/ocrDetail',
      query: {messagePushId}
    })
  } else if (type === 17 || type === 28) {
    router.push({
      path: '/sysMsgList',
      query: {type: 1}
    })
  } else if (type === 40 || type === 41) {
    // OCR人工审批通过、拒绝
    router.push({
      path: '/applyDetail',
      query: {
        documentId: jData.documentId || jData.businessId
      }
    })
  } else if (type >= 29 && type <= 34) {
    // 印章柜相关
    router.push({
      path: '/yzgMsgDetail',
      query: {
        title: '系统通知',
        id: jData.messagePushId,
        businessType: jData.businessType
      }
    })
  } else if([65,66,67,68].includes(+type)){
    //电子签章
    router.push({
      path: '/applyStampingDetail',
      query: {
        documentId: jData.businessId
      }
    })
  } else {
    router.push({
      path: '/warningDetail',
      query: {
        id,
        businessType: type,
        enterpriseId,
        enterpriseName
      }
    })
  }
}

// app角标设置
export const setBadge = (num) => {
  xda.setBadge({badge: num})
}

// 获取角标
export const getBadge = async () => {
  const sessionId = localStorage.getItem('sessionId')
  if (!sessionId) return console.error('极光推送来了但是sessionId为空！');
  
  if (isSupport()) {
    const res = await messageAmount()
    console.log('getNum', JSON.stringify(res))
    if (res.success) {
      const setBadgeRes = await xda.setBadge(res.data)
      console.log('setBadge', setBadgeRes)
    }
  }
}

export const handleEnterpriseSwitch = async (id) => {
  console.log(id)
  const deviceInfo = JSON.parse(localStorage.getItem('deviceInfo') || '{}') || {}
  const {jpush} = deviceInfo
  const res = await switchEnterprise({
    enterpriseId: id,
    registrationId: jpush?.registrationID
  })
  console.log(res)
  if (res.success) {
    localStorage.setItem('userInfo', JSON.stringify(res.data))
    localStorage.setItem('sessionId', res.data.sessionId)
    localStorage.setItem('currentStaffID', res.data.result.staffId)
    localStorage.setItem('enterpriseId', res.data.result.enterpriseId)
    res.data.mobile && localStorage.setItem('mobile', res.data.mobile)
  } else {
    Toast(res.message);
  }

  return res;
}
